import { render, staticRenderFns } from "./Inpute.vue?vue&type=template&id=6edadcbb&scoped=true&"
import script from "./Inpute.vue?vue&type=script&lang=js&"
export * from "./Inpute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edadcbb",
  null
  
)

export default component.exports